import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular-ivy";


if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://f41bf52195614164ac257a71f7271951@o183005.ingest.sentry.io/4505116440723456",
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 1.0
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));